import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { useParams } from 'react-router-dom';
import { emailPayslip, fetchPayrunById, updatePayrun } from './PayrunService';
import PayrunForm from './PayrunForm';
import { useAuth } from '../AuthProvider';
import './PayrunDetailPage.css';
import { Button, Drawer } from 'antd';
import PayslipScreen from './PayslipScreen';
export default function PayrunDetailPage() {
    const { id } = useParams();
    const [payrun, setPayrun] = useState(null);
    const [payslip, setPayslip] = useState({});
    const authContext = useAuth();
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    // Helper to format date as dd-mm-yyyy
function formatDateDMY(date) {
    if (!date) return '';
    const d = dayjs(date);
    if (!d.isValid()) return date;
    return d.format('DD-MM-YYYY');
}
    const showLoading = () => {
        setOpen(true);
        setLoading(true);

        // Simple loading mock. You should add cleanup logic in real world.
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };
    useEffect(() => {
        fetchPayrunById(id, authContext.token).then(setPayslip);
    }, [id]);


    const handleSave = async () => {
        try {
            const updated = await updatePayrun(payslip, authContext.token);
            setPayslip(updated);
            alert('Payrun updated successfully.');
        } catch (error) {
            console.error('Save failed:', error);
            alert('Failed to update payrun.');
        }
    };

    const handleFinalise = async () => {
        const updatedPayslip = { ...payslip, status: 'finalised' };
        setPayslip(updatedPayslip);
        try {
            const updated = await updatePayrun(updatedPayslip, authContext.token);
            //setPayslip(updated);
            alert('Payrun updated successfully.');
        } catch (error) {
            console.error('Save failed:', error);
            //alert('Failed to update payrun.');
        }
    };

    const handleEmail = async () => {

        try {
            const updated = await emailPayslip(payslip, authContext.token);
            //setPayslip(updated);
            alert('email sent successfully.');
        } catch (error) {
            console.error('Save failed:', error);
            //alert('Failed to update payrun.');
        }
    };
    
    const handleChange = (key, value) => {
        setPayslip(prev => ({ ...prev, [key]: value }));
    };

    
        const renderInput = (key, prefix = '', suffix = '') => {
                // Format date fields as dd-mm-yyyy
                const dateFields = ['date', 'dateFrom', 'dateTo'];
                let value = payslip && payslip[key];
                if (dateFields.includes(key)) {
                    value = formatDateDMY(value);
                }
                return (
                    <>
                        {prefix}
                        <input
                            type="text"
                            value={value}
                            onChange={e => handleChange(key, e.target.value)}
                            className="editable-input"
                        />
                        {suffix}
                    </>
                );
        };

    return (
        
        <div className="payslip-container">
            {!payslip ? <p>Loading payslip...</p> : ''}
            <h2>Payrun ID -  {renderInput('id')}</h2>
            <section className="section">
                <div className="company-info">
                    <h3>Company Info</h3>
                    <p><strong>Name:</strong> {renderInput('companyName')}</p>
                    <p><strong>Address:</strong> {renderInput('companyAddress')}</p>
                    <p><strong>Email:</strong> {renderInput('companyEmail')}</p>
                    <p><strong>Phone:</strong> {renderInput('companyPhone')}</p>
                </div>

            </section>
            <section className="section">


                
                <p><strong>Payrun Date:</strong> {renderInput('date')}</p>

                <p><strong>Period Date:</strong> {renderInput('dateFrom')}-{renderInput('dateTo')}</p>


            </section>
            <section className="section">
                <h3>Employee Info</h3>
                <p><strong>Name:</strong> {renderInput('staffName')}</p>
                <p><strong>TFN:</strong> {renderInput('staffTfn')}</p>
                <p><strong>Email:</strong> {renderInput('staffEmail')}</p>
                <p><strong>Superannuation fund:</strong> {renderInput('staffSuperannuationFundName')}</p>
                {payslip.staffEmploymentType && payslip.staffEmploymentType==='Fulltime'?<p><strong>Annual salary:</strong> ${renderInput('annualSalary')}</p>:''}
            </section>

            <section className="section">
                <h3>Pay Breakdown</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Hours</th>
                            <th>Rate</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Normal Hours</td>
                            <td>{renderInput('normalHours')}</td>
                            <td>${renderInput('basePayRate')}</td>
                            <td>${renderInput('payForNormalHours')}</td>
                        </tr>
                        <tr>
                            <td>Overtime 1</td>
                            <td>{renderInput('overtimeRate1Hours')}</td>
                            <td>${renderInput('overtimeRate1PayRate')}</td>
                            <td>${renderInput('payForOvertimeRate1Hours')}</td>
                        </tr>
                        <tr>
                            <td>Overtime 2</td>
                            <td>{renderInput('overtimeRate2Hours')}</td>
                            <td>${renderInput('overtimeRate2PayRate')}</td>
                            <td>${renderInput('payForOvertimeRate2Hours')}</td>
                        </tr>
                        <tr>
                            <td>Evening</td>
                            <td>{renderInput('eveningHours')}</td>
                            <td>${renderInput('eveningHourRate')}</td>
                            <td>${renderInput('payForEveningHours')}</td>
                        </tr>
                        <tr>
                            <td>Saturday</td>
                            <td>{renderInput('saturdayHours')}</td>
                            <td>${renderInput('saturdayHourRate')}</td>
                            <td>${renderInput('payForSaturdayHours')}</td>
                        </tr>
                        <tr>
                            <td>Sunday</td>
                            <td>{renderInput('sundayHours')}</td>
                            <td>${renderInput('sundayHourRate')}</td>
                            <td>${renderInput('payForSundayHours')}</td>
                        </tr>
                        <tr>
                            <td>Annual Leave taken</td>
                            <td>{renderInput('annualLeaveTakenHours')}</td>
                             <td>${renderInput('basePayRate')}</td>
                            <td>${renderInput('payForAnnualLeaveTakenHours')}</td>
                            
                        </tr>
                         <tr>
                            <td>Personal Leave taken</td>
                            <td>{renderInput('personalLeaveTakenHours')}</td>
                             <td>${renderInput('basePayRate')}</td>
                            <td>${renderInput('payForPersonalLeaveTakenHours')}</td>
                            
                        </tr>
                         <tr>
                            <td>LS Leave taken</td>
                            <td>{renderInput('longServiceLeaveTakenHours')}</td>
                             <td>${renderInput('basePayRate')}</td>
                            <td>${renderInput('payForLongServiceLeaveTakenHours')}</td>
                            
                        </tr>
                        <tr>
                            <td>Meal Allowance</td>
                            <td>{renderInput('mealAllowanceHours')}</td>
                            <td>${renderInput('mealAllowanceHourRate')}</td>
                            <td>${renderInput('payForMealAllowanceHours')}</td>
                        </tr>
                        <tr>
                            <td>Sleepover Allowance</td>
                            <td>{renderInput('sleepoverAllowanceHours')}</td>
                            <td>${renderInput('sleepoverAllowanceHourRate')}</td>
                            <td>${renderInput('payForSleepoverAllowanceHours')}</td>
                        </tr>
                        <tr>
                            <td>Trip Allowance</td>
                            <td>{renderInput('tripAllowanceHours')}</td>
                            <td>${renderInput('tripAllowanceHourRate')}</td>
                            <td>${renderInput('payForTripAllowanceHours')}</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section className="section">
                <h3>Summary</h3>
                <p><strong>Gross Pay:</strong> ${renderInput('totalPay')}</p>
                <p><strong>Tax Withheld:</strong> ${renderInput('taxWithheld')}</p>
                <p><strong>Net Pay:</strong> ${renderInput('netPay')}</p>
                <p><strong>Superannuation:</strong> ${renderInput('superannuation')}</p>
                <p><strong>Total Hours:</strong> {renderInput('totalHoursWorked')}</p>
            </section>
<section className="section">
                <h3>Leave Info (This period)</h3>
                <p><strong>Annual Leave Accrued:</strong> {renderInput('annualLeaveAccruedHours', '', ' hrs')}</p>
                <p><strong>Annual Leave Taken:</strong> {renderInput('annualLeaveTakenHours', '', ' hrs')}</p>
                <p><strong>Annual Leave Balance:</strong> {renderInput('annualLeaveBalanceHours', '', ' hrs')}</p>
                <p><strong>Personal Leave Accrued:</strong> {renderInput('personalLeaveAccruedHours', '', ' hrs')}</p>
                <p><strong>Personal Leave Taken:</strong> {renderInput('personalLeaveTakenHours', '', ' hrs')}</p>
                <p><strong>Personal Leave Balance:</strong> {renderInput('personalLeaveBalanceHours', '', ' hrs')}</p>
                <p><strong>Long Service Leave Accrued:</strong> {renderInput('longServiceLeaveAccruedHours', '', ' hrs')}</p>
                <p><strong>Long Service Leave Taken:</strong> {renderInput('longServiceLeaveTakenHours', '', ' hrs')}</p>
                <p><strong>Long Service Leave Balance:</strong> {renderInput('longServiceLeaveBalanceHours', '', ' hrs')}</p>
                 
            </section>

            <section className="section">
                <h3>Year-to-Date (YTD)</h3>
                <p><strong>Gross YTD:</strong> ${renderInput('grossPayYtd')}</p>
                <p><strong>Tax YTD:</strong> ${renderInput('taxWithheldYtd')}</p>
                <p><strong>Net Pay YTD:</strong> ${renderInput('netPayYtd')}</p>
                <p><strong>Super YTD:</strong> ${renderInput('superYtd')}</p>
                <p><strong>Annual Leave Accrued:</strong> {renderInput('annualLeaveAccruedHoursYTD', '', ' hrs')}</p>
                <p><strong>Annual Leave Taken:</strong> {renderInput('annualLeaveTakenYtd', '', ' hrs')}</p>
                <p><strong>Annual Leave Balance:</strong> {renderInput('annualLeaveBalanceHoursYTD', '', ' hrs')}</p>
                <p><strong>Personal Leave Accrued:</strong> {renderInput('personalLeaveAccruedHoursYTD', '', ' hrs')}</p>
                <p><strong>Personal Leave Taken:</strong> {renderInput('personalLeaveTakenYtd', '', ' hrs')}</p>
                <p><strong>Personal Leave Balance:</strong> {renderInput('personalLeaveBalanceHoursYTD', '', ' hrs')}</p>
                <p><strong>Long Service Leave Accrued:</strong> {renderInput('longServiceLeaveAccruedHoursYTD', '', ' hrs')}</p>
                <p><strong>Long Service Leave Taken:</strong> {renderInput('lslTakenYtd', '', ' hrs')}</p>
                <p><strong>Long Service Leave Balance:</strong> {renderInput('longServiceLeaveBalanceHoursYTD', '', ' hrs')}</p>
            </section>

                        <div className="save-button-container">


                {payslip && payslip.status != 'finalised' ?
                    <div>
                        <button onClick={handleSave} className="save-button">
                            Save
                        </button>
                        <button onClick={handleFinalise} className="save-button">
                            Finalise
                        </button>
                    </div> : ''}
                {payslip && payslip.status === 'finalised' ? <button onClick={handleEmail} className="save-button">
                    Email payslip
                </button> : ''}
                <button onClick={showLoading} className="save-button">
                            Preview payslip
                        </button>
                                                <Drawer
                                                        closable
                                                        destroyOnClose
                                                        title={<p>Loading Drawer</p>}
                                                        placement="right"
                                                        open={open}
                                                        loading={loading}
                                                        onClose={() => setOpen(false)}
                                                        width={900}
                                                >
                                                        {payslip && typeof payslip === 'object' && typeof payslip.then !== 'function' ? (
                                                            <PayslipScreen payslip={payslip} />
                                                        ) : (
                                                            <p>Loading payslip...</p>
                                                        )}
                                                </Drawer>
                        
            </div>

        </div>
    );
};


